<template lang="pug">
#graficoPluviosidade
    div(v-show='possuiDadosHistoricos')
        apex-charts.component.apexcharts-canvas(
            type='line',
            height='300',
            :options='options',
            :series='series'
        )
    div(v-show='!possuiDadosHistoricos')
        empty-result(
            :min-height='150',
            icon-class='mdi-alert-octagon',
            :message="$t('mensagens.monitoramento.historico.agricola.naoFoiPossivelObterHistoricoDeChuva')"
        )
</template>

<script>
import { graficoPluviosidadeAcumulada } from '@/utils/layouts/graficos';
import EmptyResult from '@/components/EmptyResult';
import ApexCharts from 'vue-apexcharts';

const JANEIRO = 1;
const DEZEMBRO = 12;

export default {
    name: 'GraficoPluviosidade',
    components: {
        ApexCharts,
        EmptyResult
    },
    data() {
        return {
            series: [],
            options: graficoPluviosidadeAcumulada()
        };
    },

    props: {
        historico: {
            type: Array,
            required: true
        }
    },

    computed: {
        possuiDadosHistoricos() {
            return this.historico && this.historico.length > 0;
        }
    },

    methods: {
        configureDados() {
            let anos = _.uniq(
                _.map(this.historico, historico => historico.ano)
            );

            _.each(anos, ano => {
                let dadosAno = _.filter(
                    this.historico,
                    historico => historico.ano === ano
                );

                this.buildSeries(dadosAno, ano);
            });

            this.buildMediaMensal();
        },

        buildSeries(dadosAno, ano) {
            this.series.push({
                name: ano.toString(),
                type: 'column',
                data: _.map(dadosAno, dado => dado.valor)
            });
        },

        buildMediaMensal() {
            let mediasMensais = [];

            for (let i = JANEIRO; i <= DEZEMBRO; i++) {
                let dadosMes = _.filter(this.historico, h => {
                    return h.mes === i;
                });

                let mediaMensal = _.meanBy(dadosMes, dado => dado.valor);

                mediasMensais.push(mediaMensal);
            }

            this.series.push({
                name: this.$t('mensagens.monitoramento.historico.agricola.mediaHistorica'),
                type: 'line',
                data: mediasMensais
            });
        }
    },

    mounted() {
        this.configureDados();
    }
};
</script>

<style>
.apexcharts-tooltip {
    background-color: white;
    border: 1px solid #e3e3e3;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    padding: 5px;
}

.apexcharts-tooltip .apexcharts-tooltip-title {
    background: #fff !important;
    align-self: flex-start;
    font-family: Arial, Helvetica, sans-serif;
    color: #333;
    border-bottom: 0px !important;
    font-weight: 600;
    font-size: 14px !important;
    padding: 5px;
    border-radius: 5px 5px 0 0;
}

.apexcharts-tooltip .apexcharts-tooltip-series-group {
    padding: 5px;
    display: flex;
    align-items: center;
}

.apexcharts-tooltip .apexcharts-tooltip-marker {
    width: 10px;
    height: 10px;
    margin-right: 5px;
}

.apexcharts-tooltip .apexcharts-tooltip-text {
    font-size: 12px;
    color: #333;
}

.apexcharts-tooltip .apexcharts-tooltip-text-y-label,
.apexcharts-tooltip .apexcharts-tooltip-text-y-value {
    display: inline-block;
}
</style>
